// import contentRequest from '~/src/api/requests/contentRequest';
// import { REQUEST_TIMEOUT, IS_PRODUCTION_ENVIROMENT } from '~/src/constants';
import all from './all_cities.json';

export interface ABNTestVariant {
    id: number,
    abn_test_id: number,
    label: string,
    traffic: number,
}
export interface ABNTest {
    id: number,
    title: string,
    name: string,
    is_active: number,
    is_auth: number,
    is_guest: number,
    variants: ABNTestVariant[]
}
export interface ApiCity {
    has_QPS: number;
    id: number,
    city_id: number,
    billing_city_id: number,
    domain: string,
    name: string,

    // возможно number | null
    region: number | null,

    dat_region_name: string,
    dat_name: string,
    pred_name: string,
    legal_entity: string,
    prefix_agreement: number,
    b2c_yandex_id: number,
    b2c_yandex_search_id: number,
    company_name: string,
    logo: string,

    // возможно number | null
    parent_city_id: unknown,

    billing_host: string,

    // 0_o  вытащил из редъюсера
    phone_code: number | '0',
    pl_available: 0 | 1,
    call_center_phone: string,
    loyalty_program_cashback: number,
    support_phone: string,
    sale_phone: string,
    dealers_phone: string,
    sale_center_city: string,
    time_zone: number,
    b2c_site_pc_css: string,

    // возможно enum
    telephony_type: number,

    hr_phone: string,
    hr_address: string,
    address: string,
    b2c_address: string,
    b2b_support_address: string,
    b2c_online_consultant_link: string,

    // возможно enum 0 / 1
    has_internet: number,
    has_ktv: number,
    has_ctv: number,
    has_telephony: number,
    has_domruclub: number,
    is_active: number,
    mvnotele2: number,
    has_billing_host_children: number,
    has_free_delivery_and_installation: number,

    props: ApiCityProps,
    abnTests: ABNTest[],
}

export interface ApiCityProps {

    // возможно enum 0 / 1
    promocode_request: number
    hide_add_product_request: number,
    self_order_active: number,

}

// null не точно, там выше проверка
export async function getCities(): Promise<ApiCity[] | null> {
    // const params = {
    //     all: IS_PRODUCTION_ENVIROMENT ? '0' : '1',
    // };
    // const resp = await contentRequest.getWithCache('/v1/geography/get-all-cities', {
    //     params: params,
    //     timeout: REQUEST_TIMEOUT,
    // });
    // return resp.data;
    // @ts-ignore
    return all;
}
